<template>
  <div class="settings_area">

    <div class="row">
      settings
    </div>

  </div>
</template>

<script>
  export default {
    name: 'settings'

  }
</script>

<style lang="scss" scoped>

</style>
